import { useContext, useEffect, useState } from 'react';
import useDashboard from 'hooks/API/GET/useDashboard';
import QcDashboard from './QcDashboard';
import SeDashboard from './SeDashboard';
import { UserContext } from 'context/UserContext';
// import UserSelect from 'components/molecules/UserSelect';
// import { ROLES } from 'utilities/constants';

function Dashboard() {
  const { isLoading, isError, data } = useDashboard({ enabled: false });
  const { data: dashboardData = {} } = data || {};
  const { userPermissions = {}, userInfo = {} } = useContext(UserContext);
  const { data: userInfoData = {} } = userInfo || {};
  const { key } = userInfoData || {};

  const [userQuery, setUserQuery] = useState('');

  return (
    <div className="mainWraper">
      {isLoading ? (
        'Loading...'
      ) : isError ? (
        'Failed to load data'
      ) : (
        <div className="container">
          <div className="row">
            {/* {key === 'QC' && <QcDashboard reviewData={dashboardData} />}
            {key === 'SUBJECT_EXPERT' && <SeDashboard reviewData={dashboardData} />} */}
          </div>
        </div>
      )}
      {/* <span>COMING SOON</span> */}
      {/* <UserSelect
        dependencies={{ query: { roles: [ROLES.ADMIN, ROLES.QC] } }}
      /> */}
    </div>
  );
}

export default Dashboard;
